import { render, staticRenderFns } from "./task-list-section.vue?vue&type=template&id=61376446"
import script from "./task-list-section.vue?vue&type=script&lang=js"
export * from "./task-list-section.vue?vue&type=script&lang=js"
import style0 from "./task-list-section.vue?vue&type=style&index=0&id=61376446&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports